// extracted by mini-css-extract-plugin
module.exports = {"root":"CartItem_root__4f5IJ","quantity":"CartItem_quantity__uG_xZ","productImage":"CartItem_productImage__ROlnt","productName":"CartItem_productName__is_5e"};